"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalStorage = void 0;
exports.getLocalStorage = function (key) {
    try {
        return localStorage.getItem(key);
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=get-local-storage.js.map